import {
  MouseFollowerType1,
  MouseFollowerType2,
  MouseFollowerType3,
  MouseFollowerType4,
  MouseFollowerType5,
  MouseFollowerType6,
  MouseFollowerType7,
  MouseFollowerType8,
  MouseFollowerType9,
  MouseFollowerType10,
  MouseFollowerType11,
  // MouseFollowerType12,
  // MouseFollowerType13,
} from './mousefollower';
import { getStyle } from './style';

export const MouseFollower = ({ value, clientId }) => {

  const style = getStyle(value?.type, value);

  const cursor = value?.cursor;
  
  switch (value?.type) {
    case 'MouseFollowerType1':
      return <MouseFollowerType1 clientId={clientId} style={style} cursor={cursor}/>;
    case 'MouseFollowerType2':
      return <MouseFollowerType2 clientId={clientId} style={style} cursor={cursor}/>;
    case 'MouseFollowerType3':
      return <MouseFollowerType3 clientId={clientId} style={style} cursor={cursor}/>;
    case 'MouseFollowerType4':
      return <MouseFollowerType4 clientId={clientId} style={style} cursor={cursor}/>;
    case 'MouseFollowerType5':
      return <MouseFollowerType5 clientId={clientId} style={style} cursor={cursor}/>;
    case 'MouseFollowerType6':
      return <MouseFollowerType6 clientId={clientId} cursor={cursor}/>;
    case 'MouseFollowerType7':
      return <MouseFollowerType7 clientId={clientId} cursor={cursor}/>;
    case 'MouseFollowerType8':
      return <MouseFollowerType8 clientId={clientId} cursor={cursor}/>;
    case 'MouseFollowerType9':
      return <MouseFollowerType9 clientId={clientId} cursor={cursor}/>;
    case 'MouseFollowerType10':
      return <MouseFollowerType10 clientId={clientId} cursor={cursor}/>;
    case 'MouseFollowerType11':
      return <MouseFollowerType11 clientId={clientId} cursor={cursor}/>;
    // case 'MouseFollowerType12':
    //   return <MouseFollowerType12 clientId={clientId} style={style} cursor={cursor}/>;
    // case 'MouseFollowerType13': 
    //   return <MouseFollowerType13 clientId={clientId} style={style} cursor={cursor}/>;
    default:
      return null;
  }
};
